/* eslint-disable */
import type { CallContext, CallOptions } from "nice-grpc-common";
import * as _m0 from "protobufjs/minimal";
import Long = require("long");

export const protobufPackage = "transaction";

export enum TransactionType {
  LEGACY = 0,
  V0 = 1,
  UNRECOGNIZED = -1,
}

export function transactionTypeFromJSON(object: any): TransactionType {
  switch (object) {
    case 0:
    case "LEGACY":
      return TransactionType.LEGACY;
    case 1:
    case "V0":
      return TransactionType.V0;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransactionType.UNRECOGNIZED;
  }
}

export function transactionTypeToJSON(object: TransactionType): string {
  switch (object) {
    case TransactionType.LEGACY:
      return "LEGACY";
    case TransactionType.V0:
      return "V0";
    case TransactionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TransactionStatus {
  REJECTED = 0,
  CONFIRMED = 1,
  PENDING = 2,
  ERROR = 3,
  UNRECOGNIZED = -1,
}

export function transactionStatusFromJSON(object: any): TransactionStatus {
  switch (object) {
    case 0:
    case "REJECTED":
      return TransactionStatus.REJECTED;
    case 1:
    case "CONFIRMED":
      return TransactionStatus.CONFIRMED;
    case 2:
    case "PENDING":
      return TransactionStatus.PENDING;
    case 3:
    case "ERROR":
      return TransactionStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransactionStatus.UNRECOGNIZED;
  }
}

export function transactionStatusToJSON(object: TransactionStatus): string {
  switch (object) {
    case TransactionStatus.REJECTED:
      return "REJECTED";
    case TransactionStatus.CONFIRMED:
      return "CONFIRMED";
    case TransactionStatus.PENDING:
      return "PENDING";
    case TransactionStatus.ERROR:
      return "ERROR";
    case TransactionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum TransactionAction {
  /** COMPLETE_BRIDGE - add more as needed */
  COMPLETE_BRIDGE = 0,
  UNRECOGNIZED = -1,
}

export function transactionActionFromJSON(object: any): TransactionAction {
  switch (object) {
    case 0:
    case "COMPLETE_BRIDGE":
      return TransactionAction.COMPLETE_BRIDGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TransactionAction.UNRECOGNIZED;
  }
}

export function transactionActionToJSON(object: TransactionAction): string {
  switch (object) {
    case TransactionAction.COMPLETE_BRIDGE:
      return "COMPLETE_BRIDGE";
    case TransactionAction.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TransactionWithIdentifier {
  identifier: string;
  transaction: string;
  transactionType: TransactionType;
}

export interface TransactionResult {
  /** Optional in protobuf is the default, so no need to specify */
  signature: string;
  status: TransactionStatus;
  identifier: string;
  /** Optional in protobuf is the default, so no need to specify */
  error: string;
  /** Optional in protobuf is the default, so no need to specify */
  logs: string[];
  /** order that it was confirmed in */
  confirmationIndex: number;
}

export interface MetadataAction {
  transactionStatus: TransactionStatus;
  /** This is now a number */
  transactionAction: TransactionAction;
  /** This is a string representation of any serializable struct */
  actionData: string;
}

export interface TransactionResults {
  result: TransactionResult | undefined;
}

export interface MetadataActions {
  actions: MetadataAction[];
}

export interface TransactionsResponse {
  transactionResults: { [key: string]: TransactionResults };
}

export interface TransactionsResponse_TransactionResultsEntry {
  key: string;
  value: TransactionResults | undefined;
}

export interface TransactionsResponseWithMetadata {
  transactionResults: { [key: string]: TransactionResults };
  metadataActions: { [key: string]: MetadataActions };
}

export interface TransactionsResponseWithMetadata_TransactionResultsEntry {
  key: string;
  value: TransactionResults | undefined;
}

export interface TransactionsResponseWithMetadata_MetadataActionsEntry {
  key: string;
  value: MetadataActions | undefined;
}

export interface BatchedTransactions {
  transactions: TransactionWithIdentifier[];
  /** use solana commetment level enum */
  commitmentLevel: number;
  /** use solana commetment level enum */
  allowFailure: boolean;
  bundle: boolean;
  skipBundleSim: boolean;
}

export interface BatchedTransactionsWithConfig {
  batches: BatchedTransactions[];
  mpcIdentifier: string;
}

export interface BatchedSignedTransactionsWithConfig {
  batches: BatchedTransactions[];
}

function createBaseTransactionWithIdentifier(): TransactionWithIdentifier {
  return { identifier: "", transaction: "", transactionType: 0 };
}

export const TransactionWithIdentifier = {
  encode(message: TransactionWithIdentifier, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }
    if (message.transaction !== "") {
      writer.uint32(18).string(message.transaction);
    }
    if (message.transactionType !== 0) {
      writer.uint32(24).int32(message.transactionType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionWithIdentifier {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionWithIdentifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.identifier = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.transaction = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.transactionType = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionWithIdentifier {
    return {
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
      transaction: isSet(object.transaction) ? globalThis.String(object.transaction) : "",
      transactionType: isSet(object.transactionType) ? transactionTypeFromJSON(object.transactionType) : 0,
    };
  },

  toJSON(message: TransactionWithIdentifier): unknown {
    const obj: any = {};
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.transaction !== "") {
      obj.transaction = message.transaction;
    }
    if (message.transactionType !== 0) {
      obj.transactionType = transactionTypeToJSON(message.transactionType);
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionWithIdentifier>): TransactionWithIdentifier {
    return TransactionWithIdentifier.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionWithIdentifier>): TransactionWithIdentifier {
    const message = createBaseTransactionWithIdentifier();
    message.identifier = object.identifier ?? "";
    message.transaction = object.transaction ?? "";
    message.transactionType = object.transactionType ?? 0;
    return message;
  },
};

function createBaseTransactionResult(): TransactionResult {
  return { signature: "", status: 0, identifier: "", error: "", logs: [], confirmationIndex: 0 };
}

export const TransactionResult = {
  encode(message: TransactionResult, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.signature !== "") {
      writer.uint32(10).string(message.signature);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.identifier !== "") {
      writer.uint32(26).string(message.identifier);
    }
    if (message.error !== "") {
      writer.uint32(34).string(message.error);
    }
    for (const v of message.logs) {
      writer.uint32(42).string(v!);
    }
    if (message.confirmationIndex !== 0) {
      writer.uint32(48).uint64(message.confirmationIndex);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionResult {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.signature = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.identifier = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.error = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.logs.push(reader.string());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.confirmationIndex = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionResult {
    return {
      signature: isSet(object.signature) ? globalThis.String(object.signature) : "",
      status: isSet(object.status) ? transactionStatusFromJSON(object.status) : 0,
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      logs: globalThis.Array.isArray(object?.logs) ? object.logs.map((e: any) => globalThis.String(e)) : [],
      confirmationIndex: isSet(object.confirmationIndex) ? globalThis.Number(object.confirmationIndex) : 0,
    };
  },

  toJSON(message: TransactionResult): unknown {
    const obj: any = {};
    if (message.signature !== "") {
      obj.signature = message.signature;
    }
    if (message.status !== 0) {
      obj.status = transactionStatusToJSON(message.status);
    }
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.logs?.length) {
      obj.logs = message.logs;
    }
    if (message.confirmationIndex !== 0) {
      obj.confirmationIndex = Math.round(message.confirmationIndex);
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionResult>): TransactionResult {
    return TransactionResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionResult>): TransactionResult {
    const message = createBaseTransactionResult();
    message.signature = object.signature ?? "";
    message.status = object.status ?? 0;
    message.identifier = object.identifier ?? "";
    message.error = object.error ?? "";
    message.logs = object.logs?.map((e) => e) || [];
    message.confirmationIndex = object.confirmationIndex ?? 0;
    return message;
  },
};

function createBaseMetadataAction(): MetadataAction {
  return { transactionStatus: 0, transactionAction: 0, actionData: "" };
}

export const MetadataAction = {
  encode(message: MetadataAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionStatus !== 0) {
      writer.uint32(8).int32(message.transactionStatus);
    }
    if (message.transactionAction !== 0) {
      writer.uint32(16).int32(message.transactionAction);
    }
    if (message.actionData !== "") {
      writer.uint32(26).string(message.actionData);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MetadataAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadataAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.transactionStatus = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.transactionAction = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.actionData = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetadataAction {
    return {
      transactionStatus: isSet(object.transactionStatus) ? transactionStatusFromJSON(object.transactionStatus) : 0,
      transactionAction: isSet(object.transactionAction) ? transactionActionFromJSON(object.transactionAction) : 0,
      actionData: isSet(object.actionData) ? globalThis.String(object.actionData) : "",
    };
  },

  toJSON(message: MetadataAction): unknown {
    const obj: any = {};
    if (message.transactionStatus !== 0) {
      obj.transactionStatus = transactionStatusToJSON(message.transactionStatus);
    }
    if (message.transactionAction !== 0) {
      obj.transactionAction = transactionActionToJSON(message.transactionAction);
    }
    if (message.actionData !== "") {
      obj.actionData = message.actionData;
    }
    return obj;
  },

  create(base?: DeepPartial<MetadataAction>): MetadataAction {
    return MetadataAction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MetadataAction>): MetadataAction {
    const message = createBaseMetadataAction();
    message.transactionStatus = object.transactionStatus ?? 0;
    message.transactionAction = object.transactionAction ?? 0;
    message.actionData = object.actionData ?? "";
    return message;
  },
};

function createBaseTransactionResults(): TransactionResults {
  return { result: undefined };
}

export const TransactionResults = {
  encode(message: TransactionResults, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.result !== undefined) {
      TransactionResult.encode(message.result, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionResults {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionResults();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.result = TransactionResult.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionResults {
    return { result: isSet(object.result) ? TransactionResult.fromJSON(object.result) : undefined };
  },

  toJSON(message: TransactionResults): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = TransactionResult.toJSON(message.result);
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionResults>): TransactionResults {
    return TransactionResults.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionResults>): TransactionResults {
    const message = createBaseTransactionResults();
    message.result = (object.result !== undefined && object.result !== null)
      ? TransactionResult.fromPartial(object.result)
      : undefined;
    return message;
  },
};

function createBaseMetadataActions(): MetadataActions {
  return { actions: [] };
}

export const MetadataActions = {
  encode(message: MetadataActions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.actions) {
      MetadataAction.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MetadataActions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMetadataActions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.actions.push(MetadataAction.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MetadataActions {
    return {
      actions: globalThis.Array.isArray(object?.actions)
        ? object.actions.map((e: any) => MetadataAction.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MetadataActions): unknown {
    const obj: any = {};
    if (message.actions?.length) {
      obj.actions = message.actions.map((e) => MetadataAction.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<MetadataActions>): MetadataActions {
    return MetadataActions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MetadataActions>): MetadataActions {
    const message = createBaseMetadataActions();
    message.actions = object.actions?.map((e) => MetadataAction.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTransactionsResponse(): TransactionsResponse {
  return { transactionResults: {} };
}

export const TransactionsResponse = {
  encode(message: TransactionsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.transactionResults).forEach(([key, value]) => {
      TransactionsResponse_TransactionResultsEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          const entry1 = TransactionsResponse_TransactionResultsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.transactionResults[entry1.key] = entry1.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionsResponse {
    return {
      transactionResults: isObject(object.transactionResults)
        ? Object.entries(object.transactionResults).reduce<{ [key: string]: TransactionResults }>(
          (acc, [key, value]) => {
            acc[key] = TransactionResults.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: TransactionsResponse): unknown {
    const obj: any = {};
    if (message.transactionResults) {
      const entries = Object.entries(message.transactionResults);
      if (entries.length > 0) {
        obj.transactionResults = {};
        entries.forEach(([k, v]) => {
          obj.transactionResults[k] = TransactionResults.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionsResponse>): TransactionsResponse {
    return TransactionsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionsResponse>): TransactionsResponse {
    const message = createBaseTransactionsResponse();
    message.transactionResults = Object.entries(object.transactionResults ?? {}).reduce<
      { [key: string]: TransactionResults }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = TransactionResults.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseTransactionsResponse_TransactionResultsEntry(): TransactionsResponse_TransactionResultsEntry {
  return { key: "", value: undefined };
}

export const TransactionsResponse_TransactionResultsEntry = {
  encode(message: TransactionsResponse_TransactionResultsEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      TransactionResults.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionsResponse_TransactionResultsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionsResponse_TransactionResultsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = TransactionResults.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionsResponse_TransactionResultsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? TransactionResults.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: TransactionsResponse_TransactionResultsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = TransactionResults.toJSON(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<TransactionsResponse_TransactionResultsEntry>,
  ): TransactionsResponse_TransactionResultsEntry {
    return TransactionsResponse_TransactionResultsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransactionsResponse_TransactionResultsEntry>,
  ): TransactionsResponse_TransactionResultsEntry {
    const message = createBaseTransactionsResponse_TransactionResultsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? TransactionResults.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseTransactionsResponseWithMetadata(): TransactionsResponseWithMetadata {
  return { transactionResults: {}, metadataActions: {} };
}

export const TransactionsResponseWithMetadata = {
  encode(message: TransactionsResponseWithMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.transactionResults).forEach(([key, value]) => {
      TransactionsResponseWithMetadata_TransactionResultsEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork(),
      ).ldelim();
    });
    Object.entries(message.metadataActions).forEach(([key, value]) => {
      TransactionsResponseWithMetadata_MetadataActionsEntry.encode({ key: key as any, value }, writer.uint32(18).fork())
        .ldelim();
    });
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionsResponseWithMetadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionsResponseWithMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          const entry1 = TransactionsResponseWithMetadata_TransactionResultsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.transactionResults[entry1.key] = entry1.value;
          }
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          const entry2 = TransactionsResponseWithMetadata_MetadataActionsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.metadataActions[entry2.key] = entry2.value;
          }
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionsResponseWithMetadata {
    return {
      transactionResults: isObject(object.transactionResults)
        ? Object.entries(object.transactionResults).reduce<{ [key: string]: TransactionResults }>(
          (acc, [key, value]) => {
            acc[key] = TransactionResults.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      metadataActions: isObject(object.metadataActions)
        ? Object.entries(object.metadataActions).reduce<{ [key: string]: MetadataActions }>((acc, [key, value]) => {
          acc[key] = MetadataActions.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: TransactionsResponseWithMetadata): unknown {
    const obj: any = {};
    if (message.transactionResults) {
      const entries = Object.entries(message.transactionResults);
      if (entries.length > 0) {
        obj.transactionResults = {};
        entries.forEach(([k, v]) => {
          obj.transactionResults[k] = TransactionResults.toJSON(v);
        });
      }
    }
    if (message.metadataActions) {
      const entries = Object.entries(message.metadataActions);
      if (entries.length > 0) {
        obj.metadataActions = {};
        entries.forEach(([k, v]) => {
          obj.metadataActions[k] = MetadataActions.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<TransactionsResponseWithMetadata>): TransactionsResponseWithMetadata {
    return TransactionsResponseWithMetadata.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TransactionsResponseWithMetadata>): TransactionsResponseWithMetadata {
    const message = createBaseTransactionsResponseWithMetadata();
    message.transactionResults = Object.entries(object.transactionResults ?? {}).reduce<
      { [key: string]: TransactionResults }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = TransactionResults.fromPartial(value);
      }
      return acc;
    }, {});
    message.metadataActions = Object.entries(object.metadataActions ?? {}).reduce<{ [key: string]: MetadataActions }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = MetadataActions.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseTransactionsResponseWithMetadata_TransactionResultsEntry(): TransactionsResponseWithMetadata_TransactionResultsEntry {
  return { key: "", value: undefined };
}

export const TransactionsResponseWithMetadata_TransactionResultsEntry = {
  encode(
    message: TransactionsResponseWithMetadata_TransactionResultsEntry,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      TransactionResults.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionsResponseWithMetadata_TransactionResultsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionsResponseWithMetadata_TransactionResultsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = TransactionResults.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionsResponseWithMetadata_TransactionResultsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? TransactionResults.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: TransactionsResponseWithMetadata_TransactionResultsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = TransactionResults.toJSON(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<TransactionsResponseWithMetadata_TransactionResultsEntry>,
  ): TransactionsResponseWithMetadata_TransactionResultsEntry {
    return TransactionsResponseWithMetadata_TransactionResultsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransactionsResponseWithMetadata_TransactionResultsEntry>,
  ): TransactionsResponseWithMetadata_TransactionResultsEntry {
    const message = createBaseTransactionsResponseWithMetadata_TransactionResultsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? TransactionResults.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseTransactionsResponseWithMetadata_MetadataActionsEntry(): TransactionsResponseWithMetadata_MetadataActionsEntry {
  return { key: "", value: undefined };
}

export const TransactionsResponseWithMetadata_MetadataActionsEntry = {
  encode(
    message: TransactionsResponseWithMetadata_MetadataActionsEntry,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      MetadataActions.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TransactionsResponseWithMetadata_MetadataActionsEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionsResponseWithMetadata_MetadataActionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = MetadataActions.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionsResponseWithMetadata_MetadataActionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? MetadataActions.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: TransactionsResponseWithMetadata_MetadataActionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = MetadataActions.toJSON(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<TransactionsResponseWithMetadata_MetadataActionsEntry>,
  ): TransactionsResponseWithMetadata_MetadataActionsEntry {
    return TransactionsResponseWithMetadata_MetadataActionsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<TransactionsResponseWithMetadata_MetadataActionsEntry>,
  ): TransactionsResponseWithMetadata_MetadataActionsEntry {
    const message = createBaseTransactionsResponseWithMetadata_MetadataActionsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? MetadataActions.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseBatchedTransactions(): BatchedTransactions {
  return { transactions: [], commitmentLevel: 0, allowFailure: false, bundle: false, skipBundleSim: false };
}

export const BatchedTransactions = {
  encode(message: BatchedTransactions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.transactions) {
      TransactionWithIdentifier.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.commitmentLevel !== 0) {
      writer.uint32(16).uint64(message.commitmentLevel);
    }
    if (message.allowFailure === true) {
      writer.uint32(24).bool(message.allowFailure);
    }
    if (message.bundle === true) {
      writer.uint32(32).bool(message.bundle);
    }
    if (message.skipBundleSim === true) {
      writer.uint32(40).bool(message.skipBundleSim);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BatchedTransactions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchedTransactions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactions.push(TransactionWithIdentifier.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.commitmentLevel = longToNumber(reader.uint64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.allowFailure = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.bundle = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.skipBundleSim = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchedTransactions {
    return {
      transactions: globalThis.Array.isArray(object?.transactions)
        ? object.transactions.map((e: any) => TransactionWithIdentifier.fromJSON(e))
        : [],
      commitmentLevel: isSet(object.commitmentLevel) ? globalThis.Number(object.commitmentLevel) : 0,
      allowFailure: isSet(object.allowFailure) ? globalThis.Boolean(object.allowFailure) : false,
      bundle: isSet(object.bundle) ? globalThis.Boolean(object.bundle) : false,
      skipBundleSim: isSet(object.skipBundleSim) ? globalThis.Boolean(object.skipBundleSim) : false,
    };
  },

  toJSON(message: BatchedTransactions): unknown {
    const obj: any = {};
    if (message.transactions?.length) {
      obj.transactions = message.transactions.map((e) => TransactionWithIdentifier.toJSON(e));
    }
    if (message.commitmentLevel !== 0) {
      obj.commitmentLevel = Math.round(message.commitmentLevel);
    }
    if (message.allowFailure === true) {
      obj.allowFailure = message.allowFailure;
    }
    if (message.bundle === true) {
      obj.bundle = message.bundle;
    }
    if (message.skipBundleSim === true) {
      obj.skipBundleSim = message.skipBundleSim;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchedTransactions>): BatchedTransactions {
    return BatchedTransactions.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchedTransactions>): BatchedTransactions {
    const message = createBaseBatchedTransactions();
    message.transactions = object.transactions?.map((e) => TransactionWithIdentifier.fromPartial(e)) || [];
    message.commitmentLevel = object.commitmentLevel ?? 0;
    message.allowFailure = object.allowFailure ?? false;
    message.bundle = object.bundle ?? false;
    message.skipBundleSim = object.skipBundleSim ?? false;
    return message;
  },
};

function createBaseBatchedTransactionsWithConfig(): BatchedTransactionsWithConfig {
  return { batches: [], mpcIdentifier: "" };
}

export const BatchedTransactionsWithConfig = {
  encode(message: BatchedTransactionsWithConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.batches) {
      BatchedTransactions.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.mpcIdentifier !== "") {
      writer.uint32(18).string(message.mpcIdentifier);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BatchedTransactionsWithConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchedTransactionsWithConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.batches.push(BatchedTransactions.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.mpcIdentifier = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchedTransactionsWithConfig {
    return {
      batches: globalThis.Array.isArray(object?.batches)
        ? object.batches.map((e: any) => BatchedTransactions.fromJSON(e))
        : [],
      mpcIdentifier: isSet(object.mpcIdentifier) ? globalThis.String(object.mpcIdentifier) : "",
    };
  },

  toJSON(message: BatchedTransactionsWithConfig): unknown {
    const obj: any = {};
    if (message.batches?.length) {
      obj.batches = message.batches.map((e) => BatchedTransactions.toJSON(e));
    }
    if (message.mpcIdentifier !== "") {
      obj.mpcIdentifier = message.mpcIdentifier;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchedTransactionsWithConfig>): BatchedTransactionsWithConfig {
    return BatchedTransactionsWithConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchedTransactionsWithConfig>): BatchedTransactionsWithConfig {
    const message = createBaseBatchedTransactionsWithConfig();
    message.batches = object.batches?.map((e) => BatchedTransactions.fromPartial(e)) || [];
    message.mpcIdentifier = object.mpcIdentifier ?? "";
    return message;
  },
};

function createBaseBatchedSignedTransactionsWithConfig(): BatchedSignedTransactionsWithConfig {
  return { batches: [] };
}

export const BatchedSignedTransactionsWithConfig = {
  encode(message: BatchedSignedTransactionsWithConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.batches) {
      BatchedTransactions.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BatchedSignedTransactionsWithConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchedSignedTransactionsWithConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.batches.push(BatchedTransactions.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchedSignedTransactionsWithConfig {
    return {
      batches: globalThis.Array.isArray(object?.batches)
        ? object.batches.map((e: any) => BatchedTransactions.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BatchedSignedTransactionsWithConfig): unknown {
    const obj: any = {};
    if (message.batches?.length) {
      obj.batches = message.batches.map((e) => BatchedTransactions.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<BatchedSignedTransactionsWithConfig>): BatchedSignedTransactionsWithConfig {
    return BatchedSignedTransactionsWithConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchedSignedTransactionsWithConfig>): BatchedSignedTransactionsWithConfig {
    const message = createBaseBatchedSignedTransactionsWithConfig();
    message.batches = object.batches?.map((e) => BatchedTransactions.fromPartial(e)) || [];
    return message;
  },
};

export type TransactionServiceDefinition = typeof TransactionServiceDefinition;
export const TransactionServiceDefinition = {
  name: "TransactionService",
  fullName: "transaction.TransactionService",
  methods: {
    sendTransactions: {
      name: "SendTransactions",
      requestType: BatchedTransactionsWithConfig,
      requestStream: false,
      responseType: TransactionsResponse,
      responseStream: false,
      options: {},
    },
    sendSignedTransactions: {
      name: "SendSignedTransactions",
      requestType: BatchedSignedTransactionsWithConfig,
      requestStream: false,
      responseType: TransactionsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface TransactionServiceImplementation<CallContextExt = {}> {
  sendTransactions(
    request: BatchedTransactionsWithConfig,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<TransactionsResponse>>;
  sendSignedTransactions(
    request: BatchedSignedTransactionsWithConfig,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<TransactionsResponse>>;
}

export interface TransactionServiceClient<CallOptionsExt = {}> {
  sendTransactions(
    request: DeepPartial<BatchedTransactionsWithConfig>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<TransactionsResponse>;
  sendSignedTransactions(
    request: DeepPartial<BatchedSignedTransactionsWithConfig>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<TransactionsResponse>;
}

export type TransactionBatchServiceDefinition = typeof TransactionBatchServiceDefinition;
export const TransactionBatchServiceDefinition = {
  name: "TransactionBatchService",
  fullName: "transaction.TransactionBatchService",
  methods: {
    sendTransactionBatch: {
      name: "SendTransactionBatch",
      requestType: BatchedTransactions,
      requestStream: false,
      responseType: TransactionsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface TransactionBatchServiceImplementation<CallContextExt = {}> {
  sendTransactionBatch(
    request: BatchedTransactions,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<TransactionsResponse>>;
}

export interface TransactionBatchServiceClient<CallOptionsExt = {}> {
  sendTransactionBatch(
    request: DeepPartial<BatchedTransactions>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<TransactionsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
